// A readable name for a clip job. Jobs from uploads and HLS streams often have
// no real title: videoTitle is empty, the raw (signed, very long) storage URL,
// or the playlist file name ("master"). Those read as noise and the long URLs
// break layouts, so fall back to what the source actually is.

const GENERIC = /^(master|index|playlist|chunklist|media|video|stream|output|source|live)(\.[a-z0-9]+)?$/i;
const SITES = [
  ["kick.com", "Kick"],
  ["twitch.tv", "Twitch"],
  ["youtube.com", "YouTube"],
  ["youtu.be", "YouTube"],
  ["rumble.com", "Rumble"],
  ["x.com", "X"],
  ["twitter.com", "X"],
];
const STORAGE = /(^|\.)(storage\.googleapis\.com|amazonaws\.com|r2\.dev|r2\.cloudflarestorage\.com)$/i;

export function jobDisplayTitle(job) {
  const title = String(job?.videoTitle || "").trim();
  if (title && !/^https?:\/\//i.test(title) && !GENERIC.test(title)) return title;

  let host = "";
  let file = "";
  try {
    const u = new URL(job?.videoUrl || "");
    host = u.hostname.replace(/^www\./, "");
    file = decodeURIComponent(u.pathname.split("/").pop() || "");
  } catch { /* not a URL */ }

  // Uploaded file: its name, minus the timestamp prefix we add on upload.
  if (STORAGE.test(host)) {
    const name = file.replace(/^\d{10,}-/, "");
    return name && !GENERIC.test(name) ? `Upload: ${name}` : "Uploaded video";
  }
  const site = SITES.find(([d]) => host === d || host.endsWith(`.${d}`))?.[1];
  if (site) return `${site} VOD`;
  // A stream playlist on a CDN (e.g. Twitch's VOD CDN): the host means nothing.
  if (GENERIC.test(file) || /\.m3u8$/i.test(file)) return "Stream VOD";
  return host || "Untitled video";
}
